"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderTagPickerOptionGroup", {
    enumerable: true,
    get: function() {
        return renderTagPickerOptionGroup;
    }
});
const _reactcombobox = require("@fluentui/react-combobox");
const renderTagPickerOptionGroup = _reactcombobox.renderOptionGroup_unstable;
